export default {
  rowSelection: false,
  fieldControl: false,
  searchMode: 'group',
  columns: [
    {
      title: '年',
      dataIndex: 'year',
      width: 100,
    },
    {
      title: '月',
      dataIndex: 'month',
      width: 100,
    },
    {
      title: '类型',
      dataIndex: 'categoryDisplay',
      width: 180,
    },
    {
      title: '月业绩目标',
      dataIndex: 'targetAmount',
      width: 180,
      ellipsis: {
        showTitle: true,
        overlayStyle: {minWidth: '50px'}
      }
    },
    {
      title: '适用门店',
      dataIndex: 'suitCompanyNames',
      width: 400,
      ellipsis: true,
    },
    {
      title: '目标业绩开始时间',
      dataIndex: 'startDate',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '目标业绩结束时间',
      dataIndex: 'endDate',
      itemType: 'dateTime',
      width: 180,
    },
    {
      title: '操作',
      render: 'actionTool',
      fixed: 'right',
      width: 300,
    },
  ],
  search: [
    {
      name: 'year',
      label: '年',
      itemType: 'date',
      picker: 'year',
    },
    {
      name: 'month',
      label: '月',
      itemType: 'custom',
      render: 'monthRender',
    },
  ],
  footer: [
    {
      label: '新增',
      type: 'primary',
      events: ['onClick:onAdd'],
    },
  ],
}
